import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/views/front/Home.vue'),
        meta: {
            title: 'XCL | Custom Parts On-Demand Manufacturing',
            description: 'Expert non-standard custom CNC machining, sheet metal fabrication, and 3D printing services. We support fast prototyping and low-volume production with MOQ 1 piece.'
        }
    },
    {
        path: '/cnc-machining',
        name: 'CNC-Machining',
        component: () => import('@/views/front/CNC_Machining/CNC_Machining.vue'),
        meta: {
            title: 'CNC Machining | XCL',
            description: 'Precision 3-axis, 4-axis, and 5-axis CNC milling and turning services. Stable tolerance control down to ±0.01mm for high-quality custom metal and plastic parts.'
        }
    },
    {
        path: '/sheet-metal',
        name: 'Sheet-metal',
        component: () => import('@/views/front/Sheet-metal/Sheet-metal.vue'),
        meta: {
            title: 'Sheet metal | XCL',
            description: 'Custom sheet metal fabrication services including bending, laser cutting, and welding. Experience versatility and cost efficiency with fast global shipping.'
        }
    },
    {
        path: '/3d-printing',
        name: '3d-printing',
        component: () => import('@/views/front/3d-printing/3d-printing.vue'),
        meta: {
            title: '3d Printing | XCL',
            description: 'Professional 3D printing services featuring FDM, SLS, SLA, PolyJet, and MJF technologies. Fast prototyping for complex geometries with no minimum order.'
        }
    },
    {
        path: '/die-casting',
        name: 'Die-Casting',
        component: () => import('@/views/front/Die-Casting/Die-Casting.vue'),
        meta: {
            title: 'Die Casting | XCL',
            description: 'High-quality custom die casting services for precision mechanicals. Lower tooling costs and rapid turnaround for low to mid-volume production.'
        }
    },
    {
        path: '/compression-molding',
        name: 'Compression_Molding',
        component: () => import('@/views/front/Compression_Molding/Compression_Molding.vue'),
        meta: {
            title: 'Compression Molding | XCL',
            description: 'Cost-effective compression molding services for high-quality, durable rubber and plastic parts. Ideal for custom mechanical components.'
        }
    },
    {
        path: '/industries/aerospace',
        name: 'Aerospace',
        component: () => import('@/views/front/Industries/Aerospace/Aerospace.vue'),
        meta: { 
            title: 'Aerospace | XCL',
            description: 'Precision machining for the aerospace industry. We deliver lightweight, high-strength components with strict quality control and traceability.' 
        }
    },
    {
        path: '/industries/automotive',
        name: 'Automotive',
        component: () => import('@/views/front/Industries/Automotive/Automotive.vue'),
        meta: { 
            title: 'Automotive | XCL',
            description: 'Custom CNC machining for automotive components and specialized motorcycle modifications. Delivering tight ±0.01mm tolerances for critical performance parts.' 
        }
    },
    {
        path: '/industries/semiconductor',
        name: 'Semiconductor',
        component: () => import('@/views/front/Industries/Semiconductor/Semiconductor.vue'),
        meta: { 
            title: 'Semiconductor | XCL',
            description: 'Ultra-precision CNC machining for semiconductor equipment components. Meeting the highest industry standards for accuracy and surface finish.' 
        }
    },
    {
        path: '/industries/medical',
        name: 'Medical',
        component: () => import('@/views/front/Industries/Medical/Medical.vue'),
        meta: { 
            title: 'Medical | XCL',
            description: 'Precision manufacturing for medical devices and wellness equipment. Safe, reliable, and highly accurate components for the healthcare sector.' 
        }
    },
    {
        path: '/industries/consumer-products',
        name: 'Consumer products',
        component: () => import('@/views/front/Industries/Consumer products/Consumerproducts.vue'),
        meta: { 
            title: 'Consumer products | XCL',
            description: 'Rapid prototyping and low-volume production for consumer products, including luxury lighting components and high-end home appliances.' 
        }
    },
    {
        path: '/industries/robotics',
        name: 'Robotics',
        component: () => import('@/views/front/Industries/Robotics/Robotics.vue'),
        meta: { 
            title: 'Robotics | XCL',
            description: 'Custom mechanical components for robotics and automation systems. Fast manufacturing to accelerate your R&D and hardware iteration.' 
        }
    },
    {
        path: '/industries/electronics',
        name: 'Electronics',
        component: () => import('@/views/front/Industries/Electronics/Electronics.vue'),
        meta: { 
            title: 'Electronics | XCL',
            description: 'Precision machining for electronics, optical instruments, custom keyboards, and sim racing hardware. Flawless surface finishes for premium tech products.' 
        }
    },
    {
        path: '/industries/new-energy',
        name: 'New Energy',
        component: () => import('@/views/front/Industries/New Energy/New_Energy.vue'),
        meta: { 
            title: 'New Energy | XCL',
            description: 'Reliable manufacturing solutions for the new energy sector. Custom parts engineered for durability and high performance in energy applications.' 
        }
    },
    {
        path: '/contact',
        name: 'Contact Us',
        component: () => import('@/views/front/contact.vue'),
        meta: { 
            title: 'Contact Us | XCL',
            description: 'Contact XCL Precision today. Our export sales team is ready to assist you with custom manufacturing solutions, DFM feedback, and EXW logistics.' 
        }
    },
    {
        path: '/about-company',
        name: 'About',
        component: () => import('@/views/front/About.vue'),
        meta: {
            title: 'About Us | XCL',
            description: 'XCL Precision is a leading CNC machining manufacturer based in Shenzhen. We specialize in providing global clients with rapid prototyping and reliable contract manufacturing.'
        }
    },
    {
        path: '/materials-and-finishes',
        name: 'Materials_Surface_Finishes',
        component: () => import('@/views/front/Materials_Surface_Finishes.vue'),
        meta: {
            title: 'Materials & Surface Finishes | XCL',
            description: 'Explore our wide selection of metals, plastics, and professional surface finishes designed to meet the exact specifications of your custom parts.'
        }
    },
    {
        path: '/quality-management',
        name: 'Quality_Management',
        component: () => import('@/views/front/Quality_Management.vue'),
        meta: {
            title: 'Quality Management | XCL',
            description: 'Our rigorous quality management ensures every custom part meets strict standards. We guarantee stable ±0.01mm tolerance control across all production runs.'
        }
    },
    {
        path: '/faq',
        name: 'FAQ',
        component: () => import('@/views/front/FAQ.vue'),
        meta: {
            title: 'FAQ | XCL',
            description: 'Find answers to frequently asked questions about our CNC machining, minimum order quantities, accepted CAD formats, and global shipping options.'
        }
    },
    {
        path: '/quote',
        name: 'quote',
        component: () => import('@/views/front/get_Instant_quote.vue'),
        meta: {
            title: 'Get an Instant Quote | XCL',
            description: 'Upload your 3D CAD files to get an instant quote for CNC machining, sheet metal, or 3D printing. Fast turnaround from prototype to production.'
        }
    }
]

// ====================== 关键在这里！！！======================
const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    // 👇 加上这段，点击链接就会自动回到顶部
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
})
// ====================== 关键结束 ======================

export default router

export function resetRouter() {
    router.push({ path: '/' })
}